<script>
  import { format } from 'svelte-i18n';

  import { FileInput } from '@client/components/file-input';
  import { SectionItem } from '@client/components/section';

  import { readFile } from '@client/utils/csv';

  export let onReset = () => {};
  export let onUpload = () => {};

  const handleFileInput = async (file) => {
    const csvText = await readFile(file);

    onUpload(csvText);
  };

  const handleRemoveFile = () => {
    onReset();
  };
</script>

<SectionItem
  borderless
  label={$format('label.UPLOAD_SPREADSHEET')}
  description={$format('label.DESCRIPTION.UPLOAD_CSV')}
>
  <FileInput
    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    id="csv"
    onLoad={handleFileInput}
    onRemove={handleRemoveFile}
  />
</SectionItem>
